"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _noop2 = _interopRequireDefault(require("lodash/noop"));

var _MdClose = require("@react-icons/all-files/md/MdClose");

var _MdExpandMore = require("@react-icons/all-files/md/MdExpandMore");

var _nanoid = require("nanoid");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Accordion = _interopRequireDefault(require("../Accordion.context"));

var _AccordionItem = require("./AccordionItem.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AccordionItem = function AccordionItem(_ref) {
  var _accordionItemRef$cur;

  var children = _ref.children,
      expanded = _ref.expanded,
      onExpand = _ref.onExpand,
      theme = _ref.theme,
      title = _ref.title;
  var itemId = (0, _react.useMemo)(function () {
    return (0, _nanoid.nanoid)();
  }, []);
  var accordionItemRef = (0, _react.useRef)(null);
  var context = (0, _react.useContext)(_Accordion["default"]);

  if (!context) {
    throw new Error('<AccordionItem /> must be a child of <Accordion />');
  }

  var behavior = context.behavior,
      closeRemainingRadioButton = context.closeRemainingRadioButton,
      name = context.name,
      radioCheckedId = context.radioCheckedId,
      setRadioCheckedId = context.setRadioCheckedId,
      type = context.type;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      icon = _useState2[0],
      setIcon = _useState2[1];

  var acordionItemWrapper = accordionItemRef === null || accordionItemRef === void 0 ? void 0 : (_accordionItemRef$cur = accordionItemRef.current) === null || _accordionItemRef$cur === void 0 ? void 0 : _accordionItemRef$cur.nextElementSibling;
  var accordionItemContentObject = acordionItemWrapper === null || acordionItemWrapper === void 0 ? void 0 : acordionItemWrapper.nextElementSibling;

  var _useState3 = (0, _react.useState)(400),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      elementHeight = _useState4[0],
      setElementHeight = _useState4[1];

  var _useState5 = (0, _react.useState)(400),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      accordionItemOverflow = _useState6[0],
      setAccordionItemOverflow = _useState6[1];

  var measuredRef = (0, _react.useCallback)(function (rNode) {
    if (rNode) {
      setElementHeight(rNode.scrollHeight);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (accordionItemContentObject) {
      var observer = new MutationObserver(function () {
        setElementHeight(accordionItemContentObject.scrollHeight);
      });
      observer.observe(accordionItemContentObject, {
        attributes: true,
        childList: true,
        characterData: false,
        subtree: true
      });
    }
  }, [accordionItemContentObject]);
  var toggleIcon = theme.accordion.item.title.toggle.icon;

  var checkRemainingRadio = function checkRemainingRadio(e) {
    var target = e.target;

    if (target.checked) {
      measuredRef(accordionItemContentObject);
      setTimeout(function () {
        setAccordionItemOverflow('visible');
      }, 1000);
    } else {
      setAccordionItemOverflow('hidden');
    }

    if (behavior === 'radio' && radioCheckedId === itemId) {
      closeRemainingRadioButton();
    }
  };

  (0, _react.useEffect)(function () {
    setRadioCheckedId(itemId);
  }, [expanded, itemId, setRadioCheckedId]);
  (0, _react.useEffect)(function () {
    var icons = {
      MdClose: _MdClose.MdClose,
      MdExpandMore: _MdExpandMore.MdExpandMore
    };
    setIcon(icons[toggleIcon]);
    setRadioCheckedId(expanded ? itemId : 0);
  }, [behavior, itemId, setRadioCheckedId, toggleIcon, theme, expanded, measuredRef, accordionItemContentObject]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_AccordionItem.StyledAccordionToggle, {
    accordionItemOverflow: accordionItemOverflow,
    defaultChecked: expanded,
    elementHeight: elementHeight,
    id: itemId,
    name: name,
    ref: accordionItemRef,
    type: behavior,
    className: "accordion-toggle",
    onClick: checkRemainingRadio,
    onChange: function onChange() {
      setRadioCheckedId(itemId);
      if (onExpand) onExpand();
    }
  }), /*#__PURE__*/_react["default"].createElement(_AccordionItem.StyledAccordionItemTitle, {
    type: type
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: itemId
  }, icon && /*#__PURE__*/_react["default"].createElement("div", null, icon), typeof title === 'string' ? /*#__PURE__*/_react["default"].createElement("span", null, title) : title)), /*#__PURE__*/_react["default"].createElement(_AccordionItem.StyledAccordionItemContent, {
    ref: measuredRef
  }, /*#__PURE__*/_react["default"].createElement("div", null, children)));
};

AccordionItem.defaultProps = {
  expanded: false,
  onExpand: _noop2["default"]
};
AccordionItem.propTypes = {
  /** Accordion item content. */
  children: _propTypes.node.isRequired,

  /** Determines if the accordion item should be initially expanded. */
  expanded: _propTypes.bool,

  /** Determines if the accordion item should be initially expanded. */
  onExpand: _propTypes.func,

  /** Theme object. Passed automatically by the ThemeProvider high-order component. */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** Title of the accordion item. */
  title: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]).isRequired
};
AccordionItem.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AccordionItem",
  "props": {
    "expanded": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Determines if the accordion item should be initially expanded.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onExpand": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "Determines if the accordion item should be initially expanded.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "children": {
      "description": "Accordion item content.",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component.",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "title": {
      "description": "Title of the accordion item.",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(AccordionItem);

exports["default"] = _default;